module.exports = __webpack_public_path__ + "static/Grupo 75-6e4407a8d204351b1aea507a93f35700.svg";